"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _architectIcons = require("@wealthmigrate/architect-icons");

var _index = require("./index.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var Box = function Box(_ref) {
  var name = _ref.name,
      items = _ref.items,
      onClick = _ref.onClick,
      children = _ref.children; // 2.1. FUNCTIONS ............................................................
  // 2.1.1. STATE

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisibility = _useState2[1]; // 2.1.1. END
  // 2.1.2. ONCLICK FUNCTION


  var handleClick = (0, _react.useCallback)(function () {
    if (onClick) {
      return onClick();
    }

    if (children) {
      return visible ? setVisibility(false) : setVisibility(true);
    }

    return null;
  }, [children, onClick, visible]); // 2.1.2. END
  // 2.1.3. RENDER ICON

  var renderIcon = (0, _react.useCallback)(function () {
    if (onClick) {
      return _react["default"].createElement(_architectIcons.ArrowRightIcon, {
        size: "small"
      });
    }

    if (children) {
      return _react["default"].createElement(_architectIcons.PlusIcon, {
        size: "small"
      });
    }

    return null;
  }, [children, onClick]); // 2.1.3. END
  // 2.1. END ..................................................................
  // 2.2. RENDER COMPONENT .....................................................

  return _react["default"].createElement(_index.BoxContainer, null, _react["default"].createElement(_index.BoxHeader, {
    isVisible: visible,
    onClick: function onClick() {
      return handleClick();
    },
    noHover: children ? true : false
  }, _react["default"].createElement("div", null, _react["default"].createElement("h4", null, name), items), renderIcon()), visible && _react["default"].createElement(_index.BoxContent, null, children)); // 2.2. END ..................................................................
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. PROP-TYPES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. DEFAULT VALUES .........................................................


Box.defaultProps = {
  visible: false,
  name: '',
  items: _propTypes["default"].node
}; // 3.1. END ....................................................................
// 3.2. TYPES ..................................................................

Box.propTypes = {
  /**  Contents within this component. */
  children: _propTypes["default"].node,

  /**  Section heading. */
  heading: _propTypes["default"].string,

  /**  Section description. */
  description: _propTypes["default"].string,

  /**  Footer heading. */
  footer_heading: _propTypes["default"].string,

  /**  Footer CTA. */
  footer_cta: _propTypes["default"].string,

  /**  CTA URL */
  footer_url: _propTypes["default"].string
}; // 3.2. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = Box; // END OF FILE #################################################################

exports["default"] = _default;